import { h, ComponentChild } from 'preact'
import SearchResult from './SearchResult'
import globals from '../../../utils/globals'
import Phrase from '../../../libs/translationsUtils/phrase'
import {
  Hit,
  ZendeskHit,
  GetItemPropsFn,
  SearchResults,
  SearchType,
  EventHit,
  SalesforceHit,
  SkilljarHit,
  FreshdeskHit,
  FederatedHit
} from './'

interface Props {
  title?: ComponentChild
  searchMetadata: SearchResults
  hits: Array<EventHit|Hit|ZendeskHit|SalesforceHit|SkilljarHit|FreshdeskHit|FederatedHit>
  highlightedIndex: number | null
  getItemProps: GetItemPropsFn
  previousResultsCount: number
  type: SearchType
  viewAllUrl: string
  setHighlightedIndex: (idx: number) => void
}

function getIndexForSearchType (type: SearchType): string {
  const communityId = globals('communityId') ?? ''
  switch (type) {
    case 'community':
      return communityId
    case 'zendesk':
      return `${communityId}-zendesk`
    case 'freshdesk':
      return `${communityId}-freshdesk`
    case 'salesforce':
      return `${communityId}-salesforce`
    case 'skilljar':
      return `${communityId}-skilljar`
    case 'federated':
      return `${communityId}-federated`
  }
}

const SearchResultsSection = ({
  title,
  searchMetadata,
  hits,
  highlightedIndex,
  getItemProps,
  previousResultsCount,
  type,
  viewAllUrl,
  setHighlightedIndex
}: Props) => {
  if (!hits.length) return null
  return (
    <div onMouseLeave={() => { setHighlightedIndex(-1) }}>
      {
            title
              ? (
                <div className='algolia-search-results-section__title'>
                  <span class='algolia-search-results-section__title-label'>{title}</span>
                  {
                viewAllUrl !== ''
                  ? (
                    <a className='algolia-search-results-section__title-link' href={viewAllUrl}>
                      <Phrase p='live.search.view.all' />
                    </a>
                    )
                  : null
                }
                </div>
                )
              : ''
            }
      <ul className='algolia-search-results'>
        {
          hits.map((hit, index) => {
            const position = searchMetadata.hitsPerPage * searchMetadata.page + index + 1
            return Object.assign({}, hit, {
              position: type === 'community' ? position + previousResultsCount : position, // bump if there's an answer
              queryID: searchMetadata.queryID,
              indexName: getIndexForSearchType(type)
            })
          }).map((hit, defaultIndex) => {
            const index = defaultIndex + previousResultsCount
            hit.topic_url = hit.topic_url ?? hit.url

            return (
              <SearchResult
                key={hit.objectID}
                isHighlited={highlightedIndex === index}
                hit={hit}
                type={type}
                index={index}
                getItemProps={getItemProps}
              />
            )
          })
        }
      </ul>
    </div>
  )
}

export default SearchResultsSection
